'use client';

import { c as _c } from "react/compiler-runtime";
import { PolicyInfo } from '@module/apis/client-side/policy';
import type { IPolicyInfo } from '@module/apis/client-side/policy/type';
import { useEffect, useState } from 'react';
import './PoliceContent.scss';
import useModalStore from '@module/stores/useModalStore';
import { BaseHttpResponseError } from '@module/utils/error/apiErrors';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@pc/components/ui/select';
function PoliceContent(t0) {
  const $ = _c(17);
  const {
    type
  } = t0;
  const {
    pushModal
  } = useModalStore();
  const [mes, setMes] = useState(null);
  const [version, setVersion] = useState(null);
  let t1;
  if ($[0] !== pushModal || $[1] !== type) {
    t1 = async v => {
      ;
      try {
        const res = await PolicyInfo({
          page: type,
          version: v
        });
        setMes(res);
      } catch (t2) {
        const err = t2;
        if (err instanceof BaseHttpResponseError) {
          pushModal({
            type: "CONFIRM_MODAL",
            id: "PoliceContent",
            options: {
              description: err.message
            }
          });
        }
      }
    };
    $[0] = pushModal;
    $[1] = type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getInfoHandler = t1;
  let t2;
  if ($[3] !== getInfoHandler || $[4] !== version) {
    t2 = () => {
      getInfoHandler(version || "");
    };
    $[3] = getInfoHandler;
    $[4] = version;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== version) {
    t3 = [version];
    $[6] = version;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== mes || $[9] !== type || $[10] !== version) {
    t4 = mes && mes.versionList.length > 1 && type !== "cast" && <div className="mt-10 mb-5 flex justify-end px-5"><Select value={version || ""} onValueChange={value => {
        setVersion(value);
      }}><SelectTrigger className="w-[240px] bg-transparent"><SelectValue placeholder={type === "privacy" ? "\uC774\uC804 \uAC1C\uC778\uC815\uBCF4\uBC29\uCE68 \uBCF4\uAE30" : "\uC774\uC804 \uC774\uC6A9\uC57D\uAD00 \uBCF4\uAE30"} /></SelectTrigger><SelectContent><SelectItem key={0} value=" ">{type === "privacy" ? "\uC774\uC804 \uAC1C\uC778\uC815\uBCF4\uBC29\uCE68 \uBCF4\uAE30" : "\uC774\uC804 \uC774\uC6A9\uC57D\uAD00 \uBCF4\uAE30"}</SelectItem>{mes.versionList.reverse().map(_temp)}</SelectContent></Select></div>;
    $[8] = mes;
    $[9] = type;
    $[10] = version;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = mes?.html || "";
  let t6;
  if ($[12] !== t5) {
    t6 = <div className="etcCon" dangerouslySetInnerHTML={{
      __html: t5
    }} />;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <div className="mt-[25px]">{t4}{t6}</div>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
function _temp(el) {
  const year = el.EnforceDate.split("-")[0];
  const month = el.EnforceDate.split("-")[1];
  const day = el.EnforceDate.split("-")[2];
  return <SelectItem key={el.version} value={el.version}>{`시행일 ${year}년 ${month}월 ${day}일`}</SelectItem>;
}
export default PoliceContent;